import React, { useState } from "react";
import { Link } from "react-router-dom";

import {
  FaBars,
  FaTimes,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

const MobileNav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [open, setOpen] = useState(null);

  const menu = [
    {
      name: "HOME",
      path: "/",
    },

    {
      name: "ABOUT SCHOOL",
      submenu: [
        { label: "The School", path: "/about" },
        { label: "Chairperson Message", path: "/chairmen" },
        { label: "Director", path: "/director" },
        { label: "Principal Message", path: "/principal-message" },
        { label: "Faculty", path: "/faculty" },
        { label: "History of School", path: "/history" },
        { label: "School Information", path: "/school-information" },
        { label: "School Management", path: "/school-management" },
        { label: "Vision and Mission", path: "/vision-mission" },
        { label: "Visiting Dignitaries", path: "/visiting-dignitaries" },
      ],
    },

    {
      name: "ADMISSIONS",
      submenu: [
        { label: "Admission", path: "/admission-form" },
        { label: "Age Criteria", path: "/age-criteria" },
        { label: "Fee Structure", path: "/fee-structure" },
        { label: "Procedure", path: "/procedure" },
        { label: "Requirements", path: "/requirement" },
      ],
    },

    {
      name: "CURRICULUM",
      submenu: [
        {
          label: "Play School & Kindergarden",
          path: "/play-kindergarden",
        },
        {
          label: "Primary School",
          path: "/primary-curriculum",
        },
        {
          label: "Middle School",
          path: "/middle-curriculum",
        },
        {
          label: "Secondary School",
          path: "/secondary-school",
        },
        {
          label: "High School",
          path: "/high-curriculum",
        },
        {
          label: "Senior Secondary",
          path: "/senior-secondary",
        },
        {
          label: "School Curriculum",
          path: "/school-curriculum",
        },
      ],
    },
  ];

  const closeMenu = () => {
    setMenuOpen(false);
    setOpen(null);
  };

  return (
    <div
      className="
        lg:hidden
        sticky
        top-0
        z-[9999]
        w-full
        bg-white
        shadow-[0_8px_30px_rgba(0,0,0,0.12)]
      "
    >
      {/* =====================================================
          MOBILE NAV HEADER
      ====================================================== */}

      <div
        className="
          w-full
          min-h-[64px]
          flex
          items-center
          justify-between
          px-4
          sm:px-5
          bg-white
        "
      >
        {/* SCHOOL NAME */}

        <Link
          to="/"
          onClick={closeMenu}
          className="
            min-w-0
            flex-1
            pr-4
          "
        >
          <h2
            className="
              text-base
              sm:text-lg
              font-bold
              text-[#07294d]
              truncate
            "
          >
            Cambridge School
          </h2>
        </Link>

        {/* MENU BUTTON */}

        <button
          type="button"
          aria-label={
            menuOpen
              ? "Close navigation menu"
              : "Open navigation menu"
          }
          onClick={() => setMenuOpen(!menuOpen)}
          className="
            flex-shrink-0
            w-11
            h-11
            rounded-xl
            flex
            items-center
            justify-center
            text-xl
            text-[#07294d]
            hover:bg-[#f1f5f9]
            active:bg-[#e8eef5]
            transition
          "
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* =====================================================
          MOBILE MENU
      ====================================================== */}

      {menuOpen && (
        <div
          className="
            border-t
            border-gray-200
            bg-white
            max-h-[calc(100vh-64px)]
            overflow-y-auto
            overscroll-contain
          "
        >

          {/* =================================================
              MAIN MENU
          ================================================= */}

          {menu.map((item, index) => (
            <div
              key={index}
              className="
                border-b
                border-gray-100
              "
            >

              {/* SIMPLE LINK */}

              {item.path ? (
                <Link
                  to={item.path}
                  onClick={closeMenu}
                  className="
                    flex
                    items-center
                    justify-between
                    px-5
                    py-4
                    text-[#07294d]
                    font-semibold
                    text-sm
                    sm:text-[15px]
                    hover:bg-[#f8fbff]
                    transition
                  "
                >
                  {item.name}
                </Link>
              ) : (
                <>

                  {/* DROPDOWN BUTTON */}

                  <button
                    type="button"
                    onClick={() =>
                      setOpen(
                        open === index
                          ? null
                          : index
                      )
                    }
                    className="
                      w-full
                      flex
                      items-center
                      justify-between
                      px-5
                      py-4
                      text-[#07294d]
                      font-semibold
                      text-sm
                      sm:text-[15px]
                      hover:bg-[#f8fbff]
                      transition
                    "
                  >

                    <span>
                      {item.name}
                    </span>

                    {open === index ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}

                  </button>

                  {/* SUBMENU */}

                  {item.submenu &&
                    open === index && (
                      <div className="bg-[#f8fbff] border-t border-gray-100">

                        {item.submenu.map(
                          (sub, i) => (
                            <Link
                              key={i}
                              to={sub.path}
                              onClick={closeMenu}
                              className="
                                block
                                px-10
                                py-3.5
                                text-sm
                                sm:text-[15px]
                                text-gray-700
                                border-b
                                border-gray-100
                                hover:bg-[#edf3fb]
                                transition
                              "
                            >
                              {sub.label}
                            </Link>
                          )
                        )}

                      </div>
                    )}

                </>
              )}

            </div>
          ))}

          {/* =================================================
              INFRASTRUCTURE
          ================================================== */}

          <div className="border-b border-gray-100">

            <button
              type="button"
              onClick={() =>
                setOpen(
                  open === 4 ? null : 4
                )
              }
              className="
                w-full
                flex
                items-center
                justify-between
                px-5
                py-4
                font-semibold
                text-[#07294d]
                text-sm
                sm:text-[15px]
                hover:bg-[#f8fbff]
                transition
              "
            >

              <span>
                INFRASTRUCTURE
              </span>

              {open === 4 ? (
                <FaChevronUp />
              ) : (
                <FaChevronDown />
              )}

            </button>

            {open === 4 && (
              <div className="bg-[#f8fbff] border-t border-gray-100">

                <Link
                  to="/classrooms"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Classrooms
                </Link>

                <Link
                  to="/library"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Library
                </Link>

                <Link
                  to="/labs"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Labs
                </Link>

                <Link
                  to="/sports"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Sports
                </Link>

                <Link
                  to="/security"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Security
                </Link>

                <Link
                  to="/transportation"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Transportation
                </Link>

                <Link
                  to="/healthcare"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Healthcare Centre
                </Link>

                <Link
                  to="/music"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                  "
                >
                  Music & Dance
                </Link>

              </div>
            )}

          </div>

          {/* =================================================
              ACTIVITIES
          ================================================== */}

          <div className="border-b border-gray-100">

            <button
              type="button"
              onClick={() =>
                setOpen(
                  open === 5 ? null : 5
                )
              }
              className="
                w-full
                flex
                items-center
                justify-between
                px-5
                py-4
                font-semibold
                text-[#07294d]
                text-sm
                sm:text-[15px]
                hover:bg-[#f8fbff]
                transition
              "
            >

              <span>
                ACTIVITIES
              </span>

              {open === 5 ? (
                <FaChevronUp />
              ) : (
                <FaChevronDown />
              )}

            </button>

            {open === 5 && (
              <div className="bg-[#f8fbff] border-t border-gray-100">

                <Link
                  to="/co-curricular"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Co-Curricular Activities
                </Link>

                <Link
                  to="/education-trips"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Education Trips
                </Link>

                <Link
                  to="/sports"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Sports
                </Link>

                <Link
                  to="/morning-assembly"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  Morning Assembly
                </Link>

                <Link
                  to="/value"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                  "
                >
                  Value Based Education
                </Link>

              </div>
            )}

          </div>

          {/* =================================================
              AWARDS
          ================================================== */}

          <Link
            to="/awards"
            onClick={closeMenu}
            className="
              block
              px-5
              py-4
              border-b
              border-gray-100
              font-semibold
              text-[#07294d]
              text-sm
              sm:text-[15px]
              hover:bg-[#f8fbff]
            "
          >
            AWARDS
          </Link>

          {/* =================================================
              FAQS
          ================================================== */}

          <Link
            to="/faqs"
            onClick={closeMenu}
            className="
              block
              px-5
              py-4
              border-b
              border-gray-100
              font-semibold
              text-[#07294d]
              text-sm
              sm:text-[15px]
              hover:bg-[#f8fbff]
            "
          >
            FAQS
          </Link>

          {/* =================================================
              CAREER
          ================================================== */}

          <Link
            to="/career"
            onClick={closeMenu}
            className="
              block
              px-5
              py-4
              border-b
              border-gray-100
              font-semibold
              text-[#07294d]
              text-sm
              sm:text-[15px]
              hover:bg-[#f8fbff]
            "
          >
            CAREER
          </Link>

          {/* =================================================
              CONTACT
          ================================================== */}

          <Link
            to="/contact"
            onClick={closeMenu}
            className="
              block
              px-5
              py-4
              border-b
              border-gray-100
              font-semibold
              text-[#07294d]
              text-sm
              sm:text-[15px]
              hover:bg-[#f8fbff]
            "
          >
            CONTACT
          </Link>

          {/* =================================================
              HELP DESK
          ================================================== */}

          <div className="border-b border-gray-100">

            <button
              type="button"
              onClick={() =>
                setOpen(
                  open === 6 ? null : 6
                )
              }
              className="
                w-full
                flex
                items-center
                justify-between
                px-5
                py-4
                font-semibold
                text-[#07294d]
                text-sm
                sm:text-[15px]
                hover:bg-[#f8fbff]
              "
            >

              <span>
                HELP DESK
              </span>

              {open === 6 ? (
                <FaChevronUp />
              ) : (
                <FaChevronDown />
              )}

            </button>

            {open === 6 && (
              <div className="bg-[#f8fbff]">

                <Link
                  to="/feedback"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                  "
                >
                  Feedback
                </Link>

              </div>
            )}

          </div>

          {/* =================================================
              STUDENT LIFE
          ================================================== */}

          <div className="border-b border-gray-100">

            <button
              type="button"
              onClick={() =>
                setOpen(
                  open === 7 ? null : 7
                )
              }
              className="
                w-full
                flex
                items-center
                justify-between
                px-5
                py-4
                font-semibold
                text-[#07294d]
                text-sm
                sm:text-[15px]
                hover:bg-[#f8fbff]
              "
            >

              <span>
                STUDENT LIFE
              </span>

              {open === 7 ? (
                <FaChevronUp />
              ) : (
                <FaChevronDown />
              )}

            </button>

            {open === 7 && (
              <div className="bg-[#f8fbff]">

                <Link
                  to="/ptm"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                    border-b
                    border-gray-100
                  "
                >
                  PTM
                </Link>

                <Link
                  to="/school-houses"
                  onClick={closeMenu}
                  className="
                    block
                    px-10
                    py-3.5
                    text-sm
                    text-gray-700
                  "
                >
                  School Houses
                </Link>

              </div>
            )}

          </div>

        </div>
      )}
    </div>
  );
};

export default MobileNav;